<template>
  <div class="Aboutus-area">
    <secBanner></secBanner>
    <el-container class="container content-area">
      <el-aside class="aside-area" width="260px">
        <ul>
          <li class="lead">关于万杰</li>
          <li>
            <router-link to="/aboutus/intro" active-class="cur" title="公司介绍">公司介绍</router-link>
          </li>
          <li>
            <router-link to="/aboutus/speech" active-class="cur" title="董事长致辞">董事长致辞</router-link>
          </li>
          <li>
            <router-link to="/aboutus/culture" active-class="cur" title="企业文化">企业文化</router-link>
          </li>
          <li>
            <router-link to="/aboutus/qualification" active-class="cur" title="企业资质">企业资质</router-link>
          </li>
          <li>
            <router-link to="/aboutus/bigevent" active-class="cur" title="大事件">大事件</router-link>
          </li>
          <li>
            <router-link to="/aboutus/videos" active-class="cur" title="视频展示">视频展示</router-link>
          </li>
        </ul>
      </el-aside>
      <div class="sub-content-area">
        <div class="breadcrumb-nav">
          您的位置：
          <!-- <router-link to="/" title="首页">首页</router-link>> -->
          <router-link to="/aboutus" title="关于我们">关于我们</router-link><span>>&nbsp;{{this.$route.name}}</span>
        </div>
        <router-view></router-view>
      </div>
    </el-container>
  </div>
</template>
<script>
import secBanner from '@/components/assembly/sec-banner'
export default {
  data () {
    return {
      subnavs: [],
      baseurl: ''
    }
  },
  components: {
    secBanner
  },
  mounted () {
  }
}
</script>
<style lang="less">
.Aboutus-area {
}
</style>



// WEBPACK FOOTER //
// src/components/Aboutus.vue